<template>
  <div class="program">
    <div class="program__content">
      <h3 class="program__title" v-if="title" data-aos="fade" data-aos-delay="100">
        {{ title }}
      </h3>

      <div class="program__items" v-if="items">
        <button type="button"
                class="program__item"
                :class="{'program__item--done' : item.done, 'program__item--next': item.next}"
                v-for="(item, idx) in items"
                :key="idx"
                @click="onProgramClick(item.id)"
                data-aos="fade" data-aos-delay="100">
            <span class="program__number">
              {{ idx + 1 }}
            </span>

          <span class="program__info">
              <span class="program__name h5">
                {{ item.name }}
              </span>
              <span class="program__time text-small">
                <Icon name="16/clock"/>

                {{ item.time }}
              </span>
            </span>

          <span class="program__icon">
              <Icon name="24/chevron-right"/>
            </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import Icon from '@/components/Icon/Icon.vue';
import { mapMutations } from 'vuex';

export default {
  name: 'Program',
  components: { Icon },
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  computed: {
    title() {
      return this.data.title;
    },
    items() {
      const { items } = this.data;

      return items && items.length ? items : null;
    },
  },
  methods: {
    ...mapMutations({
      setMode: 'app/setMode',
      setCurrentProgramId: 'app/setCurrentProgramId',
    }),

    onProgramClick(id) {
      this.setCurrentProgramId(id);
      this.setMode('first-check');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "Program";
</style>
